import {t} from "@lingui/core/macro";
import moment from "moment";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {EmptyState, SimpleTable, type Column} from "@repo/component-table";
import {doNotTranslate} from "@repo/i18n";

import type {guideTranscripts_aiGuideThreads_threads as ThreadType} from "./__graphql-types__/guideTranscripts.ts";
import {
    countNumberOfInteractions,
    formatDateHeaderString,
    formatPageInfoString,
} from "./utils.ts";

interface Props {
    threads: Array<ThreadType>;
}

const columns: Array<Column<ThreadType>> = [
    {
        label: doNotTranslate`Title`,
        dataKey: "title",
        sortable: "ascending",
        cell: (row: ThreadType) => {
            const date = moment(row.lastUpdatedAt).format("l LT");
            const title = row.title || t`Khanmigo chat from ${date}`;
            return <Link href={`${row.id}`}>{title}</Link>;
        },
    },
    {
        label: doNotTranslate`Chat source`,
        cell: (row: ThreadType) => {
            return formatPageInfoString(row);
        },
    },
    {
        label: doNotTranslate`Messages`,
        cell: (row: ThreadType) => countNumberOfInteractions(row),
    },
    {
        label: doNotTranslate`Date`,
        dataKey: "lastUpdatedAt",
        sortable: "descending",
        cell: (row: ThreadType) => {
            const date = moment(row.lastUpdatedAt).format("l");

            return formatDateHeaderString(date);
        },
        // make this sorted descending order by default
    },
    {
        label: doNotTranslate`Flagged`,
        dataKey: "flagged",
        cell: (row: ThreadType) => {
            return row.flagged ? t`Yes` : "";
        },
    },
];

export default function TableView({threads}: Props): React.ReactElement {
    return (
        <View>
            {threads.length > 0 ? (
                <SimpleTable
                    columns={columns}
                    data={threads}
                    defaultSortKey="lastUpdatedAt"
                />
            ) : (
                <EmptyState
                    message={t`No matching conversations were found.`}
                />
            )}
        </View>
    );
}
